WB.Routing = WB.Routing ||{};

WB.Routing.RouteHelper = function($route, $location, _User, LocationsDataManager) {

    this.GoToLocation = function(location) {
        _User.ActiveLocation = location;
        this.UpdateUrlForLocation();
    };
    
    this.UpdateUrlForLocation = function(location) {
        if (!$route.current.params['location']) {
            return;
        }

        location = location || _User.ActiveLocation;

        var stationParam = null;
        if (LocationsDataManager.HasNonDefaultStation(location)) {
            stationParam = location.Station.RouteString;
        }

        var newParams = angular.extend({}, $route.current.params, {
            location: location.Locality.RouteString,
            station: stationParam
        });
        $route.updateParams(newParams);
    };

};
WB.Routing.RouteHelper.$inject = ['$route', '$location', '_User', 'LocationsDataManager'];

WB.App.service('RouteHelper', WB.Routing.RouteHelper);
